import React, { MutableRefObject } from 'react';

const useDisableShiftTextSelectionRef = <ElementType extends HTMLElement>(): MutableRefObject<ElementType> => {
	const ref = React.useRef<ElementType>();

	React.useEffect(() => {
		if (!ref.current) {
			return;
		}

		const originalOnSelectionStart = document.onselectstart;

		const disableTextSelection = (event: MouseEvent) => {
			if (event.shiftKey) {
				document.onselectstart = () => false;
			}
		};

		const restoreTextSelection = () => {
			document.onselectstart = originalOnSelectionStart;
		};

		ref.current.addEventListener('mousedown', disableTextSelection);
		document.addEventListener('mouseup', restoreTextSelection);

		return () => {
			if (ref.current) {
				ref.current.removeEventListener('mousedown', disableTextSelection);
			}

			document.removeEventListener('mouseup', restoreTextSelection);
			document.onselectstart = originalOnSelectionStart;
		};
	}, []);

	return ref;
};

export default useDisableShiftTextSelectionRef;
